import React from 'react'
import { connect } from 'react-redux'
import './index.scss'
import { collapseLeftToolbar } from '../../../action/left-toolbar-state-actions'
import { collapseRightToolbar, expandRightToolbar } from '../../../action/right-toolbar-state-actions'
import { openModal } from '../../../action/positioned-modal-state'
import Profile from './profile'
import HuntWindDialog from './hunt-wind-dialog'
import PopOut from './pop-out'
import { userHasPro } from '../../../lib/util'
import Notifications from './pop-out/notifications'
import { markAsRead } from '../../../action/notification-actions'
import followers from '../../../reducer/followers'
import { showHideSubscriptionModal } from '../../../utils/subscriptionUtils'
class RightToolbar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showPopout: false,
      popoutTop: 0,
      popoutName: '',
      zoomVal: null
    }
    this.selectIcon = this.selectIcon.bind(this)
    this.hidePopout = this.hidePopout.bind(this)
    this.handleZoomChange = this.handleZoomChange.bind(this)
  }

  componentDidMount() {
    __NODE_ENV__ != 'production' && this.props.zoomLevel && this.attachZoomListener()
  }

  componentDidUpdate(prevProps) {
    if (this.props.mapReference !== prevProps.mapReference) {
      if (__NODE_ENV__ != 'production') {
        this.detachZoomListener(prevProps.mapReference)
        this.attachZoomListener()
      }
    }
    if (this.props.zoomLevel !== prevProps.zoomLevel) {
      if (!this.props.zoomLevel && __NODE_ENV__ != 'production') {
        this.detachZoomListener(this.props.mapReference)
      }
      else {
        __NODE_ENV__ != 'production' && this.attachZoomListener()
      }
    }
  }

  componentWillUnmount() {
    this.detachZoomListener(this.props.mapReference)
  }

  attachZoomListener() {
    const map = this.props.mapReference()
    if (map && map.addListener) {
      map.addListener('zoom_changed', this.handleZoomChange)
      this.setState({ zoomVal: map.getZoom() }) // Set initial zoom level
    } else {
      console.error('Map or map.addListener not found', map)
    }
  }

  detachZoomListener(mapReference) {
    const map = mapReference()
    if (map) {
      google.maps.event.clearInstanceListeners(map, 'zoom_changed', this.handleZoomChange)
    } else {
      console.error('Map or map.removeListener not found', map)
    }
  }

  handleZoomChange() {
    const map = this.props.mapReference()
    if (map) {
      this.setState({ zoomVal: map.getZoom() })
    }
  }

  hidePopout() {
    this.setState({ showPopout: false, popoutTop: 0, popoutName: '' })
  }

  selectIcon(props) {
    const { name, top } = props
    this.setState({ showPopout: true, popoutTop: top, popoutName: name })
  }

  getNewNotifications() {
    const { notifications } = this.props
    let newNotifications = 0
    notifications.forEach(entry => {
      if (!entry.read) {
        newNotifications += 1
      }
    })
    return newNotifications > 9 ? '9+' : newNotifications
  }

  getContent() {
    const selected = this.props.rightToolbarState.dialog
    switch (selected) {
      case 'profile':
        return <Profile />
      case 'notifications':
        return <Notifications />
      case 'huntWind':
        return <HuntWindDialog />
      default:
        return null
    }
  }

  render() {
    const { props, user, topOffset, openModal, rightToolbarState, collapseRightToolbar, markAsRead, auth, mapReference } = this.props,
      containerStyle = {
        top: `${topOffset}px`,
        // height: `calc(100vh - ${topOffset}px)`,
        // height: `calc(100vh - 90vh)`,
        // border: '1px solid red',
        right: '0px',
        width: '120px',
        position: 'absolute',
        zIndex: 111111
      },
      userImage = user.imageProfileUrl ? user.imageProfileUrl : '../../../../asset/default-profile.png',
      hasPro = userHasPro(user),
      newNotifications = this.getNewNotifications(),
      accessToken = auth

    return (
      <div className='right-toolbar-container' style={{ ...containerStyle }}>
        <div className='right-toolbar-base' style={{ display: this.props.selectedTab != 'map' ? 'none' : 'flex' }}>
          {
            !hasPro ? (
              <div className='right-toolbar-header' style={{ width: hasPro ? '' : '175px' }}>

                <button className='vertical-center'
                  onClick={() => { showHideSubscriptionModal(accessToken) }}
                  style={{ margin: 0, marginRight: '10px', width: '115px', height: '40px' }}>UPGRADE</button>
              </div>) : null}
          <div className='right-toolbar-icon'
            style={{ backgroundImage: `url(${'../../../../asset/Bell_Solid_589500_ldpi.png'})` }}
            onClick={() => {
              if (this.state.popoutName === 'notifications') {
                this.hidePopout()
              } else {
                if (newNotifications !== 0) {
                  markAsRead()
                }
                this.selectIcon({ name: 'notifications', top: hasPro ? 15 + 60 : 64 + 60 })
              }
            }}
          >
            {
              newNotifications !== 0 ? (
                <div className='right-toolbar-notification-count'><p className='center'>{newNotifications}</p></div>
              ) : null
            }
          </div>
          <div className='right-toolbar-icon'
            style={{ backgroundImage: `url(${'../../../../asset/Question-Mark_Solid_589500_ldpi.png'})` }}
          >
            <a href='https://www.basemap.com/app-support' target='_blank' style={{
              width: '100%',
              height: '100%',
              display: 'block'
            }}></a>
          </div>
          <div className='right-toolbar-icon'
            style={{ backgroundImage: `url(${'../../../../asset/Heart-Filled_Solid_589500_ldpi.png'})` }}
            onClick={() => {
              if (this.state.popoutName === 'saveBoundary') {
                this.hidePopout()
              } else {
                this.selectIcon({ name: 'saveBoundary', top: hasPro ? 110 + 60 : 154 + 60 })
              }
            }}
          ></div>
          {__NODE_ENV__ != 'production' && this.props.zoomLevel && (
            <div className='zoom-level-display'>
              <p>{this.state.zoomVal}</p>
              <p style={{ fontSize: 7 }}>Zoom Level</p>
            </div>
          )}
        </div>
        {
          this.state.showPopout ? <PopOut
            hidePopout={this.hidePopout.bind(this)}
            name={this.state.popoutName}
            top={this.state.popoutTop} /> : null
        }
        {
          this.getContent()
        }
      </div >
    )
  }
}

const mapStateToProps = state => {
  return {
    notifications: state.notifications,
    rightToolbarState: state.rightToolbarState,
    topOffset: state.topOffset,
    user: state.user,
    auth: state.auth.token,
    zoomLevel: state.zoomLevel,
    mapReference: state.mapReference,
    selectedTab: state.selectedTab
  }
}

const mapDispatchToProps = dispatch => ({
  collapseRightToolbar: () => dispatch(collapseRightToolbar()),
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar()),
  expandRightToolbar: props => dispatch(expandRightToolbar(props)),
  markAsRead: () => dispatch(markAsRead()),
  openModal: data => dispatch(openModal(data))
})

const openSubscriptionModalFromButton = foo2 => {
  // eslint-disable-next-line no-undef
  $('#right-top-corner-button_upgrade').click()
  this.closeDialog()
}

export default connect(mapStateToProps, mapDispatchToProps)(RightToolbar)